module.exports = __webpack_public_path__ + "img/vendor_icn.37717b93.svg";